import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {

  },
  table: {
    width: '100%',
  }
 
}))

const QuoteExport = ({
  rows,
}) => {
  const classes = useStyles()

  return (
    <div className={ classes.root }>
      <table border="1" className={ classes.table }>
        <thead>
          <tr>
            <th align="left">
              Name    
            </th>
            <th align="right">
              Amount 
            </th>
            <th align="right">
              Unit    
            </th>
            <th align="right">
              Price 
            </th>
            <th align="right">
              Total    
            </th>
            
          </tr>
        </thead>
        <tbody>
          {
            rows.map((row, i) => {

              const {
                item,
                isLink,
                group,
                depth,
                hasChildren,
              } = row
            
              const {
                resource,
              } = item

              return (
                <tr key={ i }>
                  <td align="left">
                    { resource.name }
                  </td>
                  <td align="right">
                    
                  </td>
                  <td align="right">
                    
                  </td>
                  <td align="right">
                    
                  </td>
                  <td align="right">
                    
                  </td>
                </tr>
              )
            })
          }
{/* 
          {
            // Costs Total
            !noTotals && getTotalRow({
              title: 'Costs Total',
              value: totals.costsTotal,
            })
          }

          {
            // Loop over markups
            !noTotals && settings.markupOrder.map((field, i) => {

              const markup = markups[field]

              return getQuoteEditRow({
                title: `% ${info.markupTitle(field)} Markup`,
                fieldName: `markup.${field}`,
                inputField: inputMarkups[field],
                price: markup.price,
                total: markup.total,
              })
              
            })
          }

          {
            // Markup Total
            !readOnly && !noTotals && getTotalRow({
              title: 'Markup Total',
              value: totals.markupTotal,
            })
          }

          {
            // Sub Total
            !noTotals && getTotalRow({
              title: 'Sub Total',
              value: totals.subTotal,
            })
          }

          {
            // VAT %
            !noTotals && getQuoteEditRow({
              title: `% VAT`,
              fieldName: `vat`,
              inputField: inputVat,
              price: totals.subTotal,
              total: totals.vatAmount,
            })
          }

          {
            // Grand Total
            !noTotals && getTotalRow({
              title: 'Grand Total',
              value: totals.grandTotal,
            })
          }
         */}
        </tbody>
      </table>
    </div>
  )
}

export default QuoteExport

